const fonts = {
  heading: `'Montserrat', Arial, sans-serif`,
  body: `'Inter', Arial, sans-serif`,
};

export default fonts;
